<pr-page-splash>
  <pt-workspace-selector
    [workspaceSelectors]="workspaceSelectors"
   />
</pr-page-splash>
